/// <reference path="../../include.ts" />
namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import IButton = alm.view.IButton;
	import ButtonBehavior = alm.view.ButtonBehavior;

	export class PlayButton extends View<JQuery> implements IButton {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(view:JQuery) {
			super(view);

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.playIcon = view.find('.play');
			this.pauseIcon = view.find('.pause');

			this.behavior = new ButtonBehavior(this, view.get(0));
			this.isPlaying = false;

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'block');
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'none');
			});
		}





		public implButtonOver(useTransition:boolean):void {
		}

		public implButtonOut(useTransition:boolean):void {
		}

		public implButtonDown(useTransition:boolean):void {
			trace('[PlayButton] down');
			AudioPlayer.getInstance().getClip(AudioId.lo).play();
			this.dispatchEvent(new ControllerPlayPauseEvent(ControllerPlayPauseEvent.CHANGE, this, !this.isPlaying));
		}

		public implButtonUp(useTransition:boolean):void {
		}

		public implButtonClick(useTransition:boolean):void {
		}

		public implButtonChangeEnabled(isEnabled:boolean, useTransition:boolean):void {
		}





		public setState(isPlaying:boolean):void {
			this.isPlaying = isPlaying;
			trace('[PlayButton] setState :', this.isPlaying);

			if (this.isPlaying) {
				this.playIcon.css('display', 'none');
				this.pauseIcon.css('display', 'block');
			} else {
				this.playIcon.css('display', 'block');
				this.pauseIcon.css('display', 'none');
			}
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private behavior:ButtonBehavior;
		private playIcon:JQuery;
		private pauseIcon:JQuery;
		private isPlaying:boolean;
	}
}
